module.exports = __webpack_public_path__ + "static/mujeres004-fd1afb19d780999a2f8b0efcbe235e34.jpg";